import { Typography } from "@mui/material";
import { palette, spacing } from "../../../styles/theme";
import { FlexColBox, Link } from "../../../common/components";
import { Trans, useTranslation } from "react-i18next";

const QuoteSection = () => {
  const { t } = useTranslation();
  return (
    <FlexColBox>
      <FlexColBox
        sx={{
          borderRadius: "4px",
          border: `1px solid transparent`,
          opacity: 0.8,
          background: `linear-gradient(90deg, rgba(84, 172, 222, 0.04) 0%, rgba(169, 84, 222, 0.04) 100%), ${palette.lightBorderGradient}`,
        }}
        padding={{
          xs: spacing.mediumMobile,
          lg: spacing.mediumDesktop,
        }}
        gap={{ xs: spacing.smallMobile, lg: spacing.smallDesktop }}
      >
        <Typography variant="textRegularBold" color={palette.brand.darkBlue}>
          {t("pricing.requestQuote")}
        </Typography>
        <Typography variant="textSm" color={palette.grey.nearBlack}>
          <Trans i18nKey={"pricing.requestQuoteInfo"}>
            Add the product to your cart or email
            <Link to={"mailto:info@jameo.com"} style={{ fontSize: "12px" }}>
              info@jameo.com
            </Link>
            to request a quote.
          </Trans>
        </Typography>
      </FlexColBox>
    </FlexColBox>
  );
};

export default QuoteSection;
